"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var browser_rum_1 = require("@datadog/browser-rum");
var minimatch_1 = require("minimatch");
var validator_1 = __importDefault(require("validator"));
var Sentry = __importStar(require("@sentry/react"));
var ga_1 = require("../../app/util/ga");
var types_1 = require("./types");
var types_2 = require("../../app/util/types");
var requests_1 = require("../../app/util/requests");
var actions_1 = __importDefault(require("../../user/actions"));
var actions_2 = __importDefault(require("../../app/components/pages/RootPage/actions"));
var reducers_1 = require("../reducers");
var isGetOTPSuccess = function (email) { return ({
    type: types_1.GET_OTP_EMAIL_SUCCESS,
    payload: email,
}); };
var isGetOTPPending = function () { return ({
    type: types_1.GET_OTP_EMAIL_PENDING,
}); };
var isGetOTPError = function (errorMessage) { return ({
    type: types_1.GET_OTP_EMAIL_ERROR,
    payload: errorMessage,
}); };
var setEmailValidator = function (payload) { return ({
    type: types_1.SET_EMAIL_VALIDATOR,
    payload: payload,
}); };
var isVerifyOTPError = function () { return ({
    type: types_1.VERIFY_OTP_ERROR,
}); };
var isVerifyOTPPending = function () { return ({
    type: types_1.VERIFY_OTP_PENDING,
}); };
var isResendOTPSuccess = isGetOTPSuccess;
var isResendOTPPending = function () { return ({
    type: types_1.RESEND_OTP_PENDING,
}); };
var isResendOTPError = isVerifyOTPError;
var isResendOTPDisabled = function (errorMessage) { return ({
    type: types_1.RESEND_OTP_DISABLED,
    payload: errorMessage,
}); };
var isLoggedInSuccess = function (user) { return ({
    type: types_1.IS_LOGGED_IN_SUCCESS,
    payload: user,
}); };
var isLoggedOut = function () { return ({ type: types_1.IS_LOGGED_OUT }); };
var getEmailValidationGlobExpression = function () {
    return function (dispatch, getState) {
        var login = getState().login;
        var emailValidator = login.emailValidator;
        if (emailValidator !== reducers_1.defaultEmailValidator)
            return;
        requests_1.get('/api/login/emaildomains').then(function (response) {
            if (response.ok) {
                response.text().then(function (expression) {
                    var globValidator = new minimatch_1.Minimatch(expression, {
                        noext: false,
                        noglobstar: false,
                        nobrace: false,
                        nonegate: true,
                    });
                    dispatch(setEmailValidator(function (email) {
                        return (globValidator.match(email) &&
                            validator_1.default.isEmail(email, { allow_utf8_local_part: false }));
                    }));
                });
            }
        });
    };
};
/**
 * Called when user enters email and waits for OTP.
 */
var getOTPEmail = function (email) {
    return function (dispatch, getState) {
        dispatch(actions_2.default.closeSnackbar());
        var login = getState().login;
        var formVariant = login.formVariant;
        var pendingAction;
        var successAction;
        var errorAction;
        var disableResendForDuration = function (duration) {
            if (duration === void 0) { duration = 20000; }
            dispatch(isResendOTPDisabled());
            // reenable after duration
            setTimeout(function () { return dispatch(isResendOTPSuccess(email)); }, duration);
        };
        if (types_2.loginFormVariants.isEmailView(formVariant)) {
            pendingAction = function () {
                return dispatch(isGetOTPPending());
            };
            successAction = function () {
                dispatch(isGetOTPSuccess(email));
                disableResendForDuration();
            };
            errorAction = function () { return dispatch(isGetOTPError()); };
        }
        else {
            pendingAction = function () {
                return dispatch(isResendOTPPending());
            };
            successAction = function () { return disableResendForDuration(); };
            errorAction = function () { return dispatch(isResendOTPError()); };
        }
        pendingAction();
        return requests_1.postJson('/api/login/otp', { email: email })
            .then(function (response) {
            if (response.ok) {
                successAction();
                return null;
            }
            if (response.status === 401) {
                // Unauthorized
                errorAction();
                dispatch(actions_2.default.setErrorMessage(response.statusText));
                return null;
            }
            return response.json().then(function (json) {
                var message = json.message;
                errorAction();
                dispatch(actions_2.default.setErrorMessage(message));
            });
        })
            .catch(function () {
            errorAction();
            dispatch(actions_2.default.setErrorMessage('Network connectivity failed.'));
            return null;
        });
    };
};
// Checks if there is an existing session.
var isLoggedIn = function () { return function (dispatch) {
    return requests_1.get('/api/login/isLoggedIn').then(function (response) {
        var isOk = response.ok;
        return response.json().then(function (json) {
            if (isOk) {
                var user = json.user;
                browser_rum_1.datadogRum.setUser({
                    id: user.id,
                    email: user.email,
                });
                dispatch(isLoggedInSuccess(user));
            }
            else {
                browser_rum_1.datadogRum.removeUser();
                dispatch(isLoggedOut());
            }
        });
    });
}; };
/**
 * Called when user enters OTP and submits for verification.
 */
var verifyOTP = function (otp) {
    return function (dispatch, getState) {
        dispatch(actions_2.default.closeSnackbar());
        var login = getState().login;
        var email = login.email;
        dispatch(isVerifyOTPPending());
        return requests_1.postJson('/api/login/verify', { email: email, otp: otp }).then(function (response) {
            var isOk = !!response.ok;
            return response.json().then(function (json) {
                if (isOk) {
                    dispatch(actions_2.default.setSuccessMessage('OTP Verified'));
                    dispatch(isLoggedIn());
                }
                else {
                    // Sentry analytics and Google Analytics: otp fail > sign in fails
                    Sentry.captureMessage('submit otp unsuccessful');
                    ga_1.GAEvent('login page', 'otp', 'unsuccessful');
                    var message = json.message;
                    dispatch(isVerifyOTPError());
                    dispatch(actions_2.default.setErrorMessage(message));
                }
            });
        });
    };
};
var logout = function () { return function (dispatch) {
    return requests_1.get('/api/logout').then(function (response) {
        if (response.ok) {
            dispatch(isLoggedOut());
            // Wipe user data on log out.
            dispatch(actions_1.default.wipeUserState());
        }
        else {
            console.error(response);
        }
    });
}; };
exports.default = {
    getEmailValidationGlobExpression: getEmailValidationGlobExpression,
    getOTPEmail: getOTPEmail,
    verifyOTP: verifyOTP,
    isLoggedIn: isLoggedIn,
    logout: logout,
};
